<template>
    <div class="header" :class="{'header-active': isShow}">
      <div class="def-width display-flex justify-content-between align-items-center margin-center">
        <div class="logo">
          <img :src="`${imgURI}/static/logo.png`"/>
        </div>
        <ul class="user-no-select header-ul display-flex" :class="{'header-ul-active': isShow}">
          <li :class="{'checked-item': setNum === index}" class="display-flex align-items-center cursor-pointer" v-for="(item, index) in menuList" :key="index" @click.stop="selectMsg(item, index)">
            <span class="bold">{{item.msg}}</span>
<!--            v-if="item.childShow"-->
            <div class="header-ul-child text-center font-14" >
              <div class="header-ul-child-text" :class="{'checked-item-child': setChildNum === childIndex}" v-for="(child, childIndex) in item.childItem" @click.stop="goChild(child, childIndex)" :key="childIndex">{{child.msg}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
import config from '@/config/index'
export default {
  name: 'topHead',
  props: {
    setNum: {
      type: Number,
      default: 0
    },
    setChildNum: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      menuList: [
        {
          msg: '首页',
          url: '/',
          childItem: []
        },
        {
          msg: '关于我们',
          url: '/about',
          childItem: []
        },
        {
          msg: '电商学院',
          url: '/collegeIntro'
        },
        {
          msg: '品牌出海',
          url: '/sea',
          childItem: []
        },
        {
          msg: '商务合作',
          url: '/businessIndex',
          childItem: [
            {
              msg: '线上资源',
              url: '/businessOnline'
            },
            {
              msg: '线下资源',
              url: '/businessoffline'
            }
          ]
        },
        {
          msg: '人才通道',
          url: '/talentIndex',
          childItem: []
        }
      ],
      imgURI: config.imgURI,
      isShow: false
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    // window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.isShow = window.scrollY > 50
    },
    selectMsg (i, index) {
      if (i.url) {
        this.$router.push(i.url)
      }
    },
    goChild (i, index) {
      this.$router.push(i.url)
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  margin: 0 auto;
  border-bottom: 2px solid rgba(255, 255, 255, 0.4);
  position: relative;

  .header-ul{
    color: #FFFFFF;
    li{
      padding-top: 30px;
      padding-bottom: 16px;
      margin-left: 104px;
      position: relative;
    }
    .checked-item{
      position: relative;
      top: 1px;
      border-bottom: 2px solid #FFFFFF;
    }
    li:nth-of-type(2):hover, li:nth-of-type(3):hover{
      .header-ul-child{
        display: block;
      }
    }
    .header-ul-child{
      position: absolute;
      top: 70px;
      left: -8px;
      background-color: #ffffff;
      width: 80px;
      display: none;
      z-index: 99;

      .header-ul-child-text{
        width: 100%;
        height: 30px;
        line-height: 30px;
        color: #aaa;
      }
      .header-ul-child-text:hover{
        color: #031217;
        background: rgb(215,225,253);
      }
      .checked-item-child{
        color: #031217;
        background: rgb(215,225,253);
      }
    }
  }

  .logo{
    position: relative;
    top: 10px;
    img{
      width: 150px;
    }
  }
}
.header-active{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  background: #ffffff;
  box-shadow: 0 4px 6px rgba(39, 39 ,39, 0.16);
  z-index: 999;
}
.header-ul-active{
  color: #333333 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/header.vue